import { RefSoustypeUtilisateur } from '../../droits/models/ref-soustype-utilisateur.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EntrepriseBase {
    static jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        estAdherent: { key: 'estAdherent', optional: true },
        refSousType: { key: 'refSousType', converter: new (ClassConverterFactory.build(RefSoustypeUtilisateur))(), optional: true },
        telephone: { key: 'telephone', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' }
    };

    public id: number;
    public raisonSociale: string;
    public estAdherent: boolean;
    public refSousType: RefSoustypeUtilisateur;
    public telephone: string;
    public mail: string;
}
